import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=0c21d055&"
import script from "./course-list.vue?vue&type=script&lang=ts&"
export * from "./course-list.vue?vue&type=script&lang=ts&"
import style0 from "./course-list.vue?vue&type=style&index=0&id=0c21d055&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports